/** Client-side sanity limits; the server enforces the real ones (spec "Intake
 *  and limits") and these only warn early. */
export const MAX_BATCH_FILES = 500;
export const MAX_FILE_BYTES = 100 * 1024 * 1024;
// The whole upload; the ingress/nginx body limit (101m) sits just above it.
export const MAX_BATCH_BYTES = 100 * 1024 * 1024;

export function formatBytes(n: number): string {
  if (n < 1024) return `${n} B`;
  if (n < 1024 * 1024) return `${(n / 1024).toFixed(1)} KB`;
  if (n < 1024 * 1024 * 1024) return `${(n / (1024 * 1024)).toFixed(1)} MB`;
  return `${(n / (1024 * 1024 * 1024)).toFixed(2)} GB`;
}

export interface FileSanity { count: number; bytes: number; warnings: string[] }

export function sanityCheck(files: File[]): FileSanity {
  const bytes = files.reduce((s, f) => s + f.size, 0);
  const warnings: string[] = [];
  // A zip's entry count is unknown client-side, so only count loose files.
  const loose = files.filter((f) => !f.name.toLowerCase().endsWith(".zip")).length;
  if (loose > MAX_BATCH_FILES) {
    warnings.push(`Too many files (${loose}); the limit is ${MAX_BATCH_FILES} per batch.`);
  }
  const big = files.filter((f) => f.size > MAX_FILE_BYTES);
  if (big.length) {
    warnings.push(`${big.length} file(s) exceed ${formatBytes(MAX_FILE_BYTES)}: ${big.map((f) => f.name).join(", ")}`);
  }
  if (bytes > MAX_BATCH_BYTES) {
    warnings.push(`This upload is ${formatBytes(bytes)}; the limit is ${formatBytes(MAX_BATCH_BYTES)} per batch. Split it into smaller batches.`);
  }
  return { count: files.length, bytes, warnings };
}
